import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import ENUMS from '../../../enums';
import ListItem from './ListItem';
import Spin from '../../../components/loading';
import ShowForPermission from '../../../components/ShowForPermission';

import * as adsActions from '../../../redux/ads/actions';
import AdsFilter from '../Filter';
import submitForm from '../../../utils/submitForm';

class AdsList extends Component {
  constructor(props) {
    super(props);

    const currentPage = 1;
    const pageSize = 100;
    this.state = {
      currentPage,
      pageSize,
      sortType: 'acs',
      query: `pageNumber=${currentPage}&&pageSize=${pageSize}`
    };
  }

  componentDidMount() {
    this.props.actions.getAdsList(this.state.query);
  }

  invisibleAd = id => {
    const isVisible = false;
    this.props.actions.changeAdVisibility(id, isVisible);
  };

  visibleAd = id => {
    const isVisible = true;
    this.props.actions.changeAdVisibility(id, isVisible);
  };

  deleteAd = id => {
    this.props.actions.deleteAd(id);
  };

  defaultAd = (id, isDefault) => {
    const ad = {
      id: id,
      isDefault: isDefault
    };
    this.props.actions.defaultAd(ad);
  };

  applyFilters = event => {
    const queryString = submitForm(event);
    console.log('queryString',queryString);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  sortTable = query => {
    this.setState({ sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.pageSize);
      this.props.actions.getAdsList(searchQuery);
    });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  render() {
    return (
      <Spin spinning={this.props.loading}>
        <section className="page-header">
          <h1>{locales('titles.manage.ads')}</h1>
          <div className="form-actions">
            <ShowForPermission permission={ENUMS.PERMISSIONS.values.NEW_AD}>
              <Link to="/ads/add" className="btn btn-success">
                <i className="fa fa-plus"></i>
                {locales('titles.add.new.ad')}
              </Link>
            </ShowForPermission>
          </div>
        </section>
        <AdsFilter
          applyFilters={this.applyFilters}
          filterAndSort={this.filterAndSort}
          pageNumber={this.state.currentPage}
        />
        <section className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">
              <i className="fa fa-pencil"></i>
              {locales('titles.ads.list')}
            </h3>
          </div>
          <div className="panel-body">
            <table className="table table-hover table-light table-striped ">
              <thead className="thead-dark">
                <tr>
                  <th className="text-center" width="10%">
                    {locales('labels.row')}
                  </th>
                  <th className="text-center" width="40%">
                    {locales('labels.ad.image')}
                  </th>
                  <th className="text-center pointer" width="10%">
                    {locales('labels.display.order')}
                  </th>
                  <th className="text-center pointer" width="20%">
                    {locales('labels.display.status')}
                  </th>
                  <th className="text-center"></th>
                </tr>
              </thead>
              <tbody>
                {this.props.adsList && this.props.adsList.length ? (
                  this.props.adsList.map((ad, ix) => (
                    <ListItem
                      key={ad.id + Math.random()}
                      id={ad.id}
                      ix={ix}
                      imageUrl={ad.imageUrl}
                      displayOrder={ad.displayOrder}
                      adUrl={ad.adUrl}
                      isVisible={ad.isVisible}
                      pageNumber={this.state.currentPage}
                      pageSize={this.state.pageSize}
                      visibleAd={this.visibleAd}
                      invisibleAd={this.invisibleAd}
                      deleteAd={this.deleteAd}
                      isDefault={ad.isDefault}
                      defaultAd={this.defaultAd}
                    />
                  ))
                ) : (
                  <tr className="text-center">
                    <td className="alert alert-info" colSpan="5">
                      {locales('alerts.noRecord')}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </Spin>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.adsReducer.adsListLoading,
  error: state.adsReducer.adsListReject,
  failed: state.adsReducer.adsListFailed,
  failedMessage: state.adsReducer.adsListFailedMassage,
  success: state.adsReducer.adsListSuccess,
  adsList: state.adsReducer.adsList
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getAdsList: query => dispatch(adsActions.getAdsList(query)),
    changeAdVisibility: (id, visibility) => dispatch(adsActions.changeAdVisibility(id, visibility)),
    deleteAd: id => dispatch(adsActions.deleteAd(id)),
    defaultAd: id => dispatch(adsActions.defaultAd(id))
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AdsList);
